<template>

</template>

<script>
import { loginMixin } from "../../../assets/js/mixin/global";
import Cookies from "js-cookie";

export default {
  name: "index",
  mixins: [loginMixin],
  data() {
    return {

    }
  },
  mounted() {
    if (this.alreadyLogged) {
      this.$router.push('/cvs')
    }else {
      let url = `/auth-signin?type=login&account_type=cv_account&identity=${this.$route.params.identity}`
      window.location.href = url
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>